export class PaymentInfo {
    constructor({
        cardNumber = null,
        cardType = null,
        dueDate = null,
        paymentFees = null,
        personalDataConsent = false,
        checkTerms = false,
        typeAccount = null,
        numberAccount = null,
        bank = null,
        paymentType = false,
    } = {}) {
        this.cardNumber = cardNumber;
        this.cardType = cardType;
        this.dueDate = dueDate;
        this.paymentFees = paymentFees;
        this.personalDataConsent = personalDataConsent;
        this.checkTerms = checkTerms;
        this.typeAccount = typeAccount;
        this.numberAccount = numberAccount;
        this.bank = bank;
        this.paymentType = paymentType;
    }
}
